<template>
  <v-autocomplete @input="setSnippet" :value="value" ref="snippetSelect" :items="snippets" item-text="name"
    item-value="id" :label="label || 'Select a Snippet'" :error-messages="errorMessages" :disable="disabled"
    return-object required :rules="rules" :filter="snippetSearchFilter" :append-outer-icon="previewIcon"
    @click:append-outer="doPreview" hint="Check is the current default template" persistent-hint>
    <template v-slot:selection="{ attr, on, item, selected }">
      <v-icon color="green" right v-if="item.is_default">
        mdi-check
      </v-icon>
      <span v-text="item.name"></span>
    </template>
    <template v-slot:item="{ item }">
      <v-list-item-content>
        <v-list-item-title v-text="item.name"></v-list-item-title>
      </v-list-item-content>
      <v-list-item-action>
        <v-chip v-if="item.is_default">
          <v-icon left color="green">mdi-check</v-icon>
          <span v-text="item.is_default ? 'Default' : ''"></span>
        </v-chip>
      </v-list-item-action>
    </template>
  </v-autocomplete>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { R4UtilsApi, EmailTemplateApi, HtmlSnippetApi } from '../../services'

export default {
  name: 'html-snippet-select',
  props: {
    value: {
      type: [Number, String],
      required: false
    },
    snippetTypeFilter: {
      type: String,
      required: true,
      default: 'EmailTemplateFooter'
    },
    errorMessages: {
      type: Array
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    rules: {
      type: Array,
      required: false,
      default: () => []
    },
    label: {
      type: String,
      required: false
    },
    showPreview: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      snippetsList: []
    }
  },
  computed: {
    ...mapState('DealerStore', ['dealers', 'dealer']),
    snippets: function () {
      if (this.snippetTypeFilter) {
        return this.snippetsList.filter((s) => {
          return s.type === this.snippetTypeFilter
        })
      } else {
        return this.snippetsList
      }
    },
    previewIcon: function () {
      if (this.showPreview) {
        if (this.value) {
          return 'mdi-foot-print'
        } else {
          return ''
        }
      } else {
        return ''
      }
    },
    defaultSnippetValue: function () {
      const snippet = this.snippets.find(snip => {
        return snip.is_default
      })
      return snippet ? snippet.id : null
    }
  },
  watch: {
    // emit the default snipet id for parent to set if desired
    defaultSnippetValue(newVal) {
      if (newVal) {
        this.$emit('default-snippet-id', newVal)
      }
    }
  },
  mounted: function () {
    this.loadSnippets()
  },

  methods: {
    ...mapMutations('DealerStore', ['saveDealer']),
    loadSnippets: function () {
      HtmlSnippetApi.fetch()
        .then(resp => {
          this.snippetsList = resp.data
        })
    },
    setSnippet: function (selectedSnippet) {
      this.$emit('input', selectedSnippet ? selectedSnippet.id : null)
    },
    snippetSearchFilter: function (item, queryText, itemText) {
      const snippetName = item.name.toLowerCase()
      const searchText = queryText.toLowerCase()

      return snippetName.indexOf(searchText) > -1
    },
    doPreview: function () {
      const snippet = this.snippets.find(sn => sn.id === this.value)
      EmailTemplateApi.getHtmlLiveView({ dealerId: this.dealer.id, htmlTemplate: snippet.template_html, isCampaign: false })
        .then((htmlTemplatePreview) => {
          R4UtilsApi.openHtmlInNewTab(htmlTemplatePreview.data.html)
        })
        .catch(error => {
          this.$flash({
            showClose: true,
            message: 'Error Loading Email Templates. Reload to try again.' + error.message,
            type: 'error',
            duration: 0
          })
        })
    }
  }
}
</script>
